import { For, Show } from "solid-js";
import { Panel } from "../layout/Panel.tsx";
import { alerts } from "../../stores/alerts.ts";
import { relTime } from "../../lib/relTime.ts";
import type { Alert } from "@houston/shared";

const SEV_STYLE: Record<Alert["severity"], { border: string; bg: string; text: string; icon: string }> = {
  critical: {
    border: "border-l-[var(--color-critical)]",
    bg: "bg-[rgba(255,59,59,0.06)]",
    text: "text-[var(--color-critical)] text-glow-critical",
    icon: "▲",
  },
  warning: {
    border: "border-l-[var(--color-warning)]",
    bg: "bg-[rgba(255,178,36,0.04)]",
    text: "text-[var(--color-warning)] text-glow-warning",
    icon: "◆",
  },
  info: {
    border: "border-l-transparent",
    bg: "bg-transparent",
    text: "text-[var(--color-info)]",
    icon: "●",
  },
};

export function AlertsFeed() {
  return (
    <Panel title="Alerts" span="col-span-4 row-span-1">
      <Show
        when={alerts.active.length > 0}
        fallback={<NominalState />}
      >
        <ul class="space-y-1.5 max-h-full overflow-auto">
          <For each={alerts.active}>
            {(a) => {
              const s = SEV_STYLE[a.severity];
              return (
                <li class={`flex items-start gap-2 rounded border-l-2 px-3 py-2 ${s.border} ${s.bg}`}>
                  <span class={`mt-0.5 font-mono text-[10px] ${s.text}`}>{s.icon}</span>
                  <div class="flex-1 min-w-0">
                    <div class={`font-mono text-[10px] font-bold uppercase tracking-wider ${s.text}`}>
                      {a.title}
                    </div>
                    <div class="mt-0.5 font-mono text-[9px] text-[var(--color-text-secondary)] truncate">
                      {a.message}
                    </div>
                  </div>
                  <span class="font-mono text-[8px] text-[var(--color-text-dim)] whitespace-nowrap">
                    {relTime(a.firedAt)}
                  </span>
                </li>
              );
            }}
          </For>
        </ul>
      </Show>
    </Panel>
  );
}

function NominalState() {
  return (
    <div class="flex h-full items-center justify-center">
      <div class="text-center">
        <div class="font-display text-sm font-bold uppercase tracking-[0.2em] text-[var(--color-healthy)] text-glow-healthy animate-glow-breathe">
          Nominal
        </div>
        <div class="mt-1 font-mono text-[9px] uppercase tracking-wider text-[var(--color-text-dim)]">
          No active alerts
        </div>
      </div>
    </div>
  );
}
